/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';
import { ActionTemplate } from '@src/app/model/ActionTemplate';
import { Frequency } from '@src/app/model/frequency';

export class RequestTemplate extends AbstractObject {
    name: string;
    description: string;

    agentTeamId: uuid;
    title?: string; // not really there...

    categoryId: uuid;
    priorityId: uuid;
    srTopic: string;
    srClass: string;
    frequencyId: uuid;
    frequency: Frequency;

    followOnId: uuid;
    followOnAfter: number;
    followOn: RequestTemplate;

    recurring_jobs_count: string;
    open_requests_count: string;

    actions: ActionTemplate[] = [];

    ownerOmcRole: string;
    followerOmcRole: string;

    constructor(o: Partial<RequestTemplate> = {}) {
        super(o);
    }
}
